import InstructionsTableHelper from './instruction-table-helper';
import InstructionAttachmentsTableHelper from './instruction-attachments-table-helper';


const InstructionHelpers = {
    TableMain: InstructionsTableHelper,
    TableAttachments: InstructionAttachmentsTableHelper,
}

export default InstructionHelpers;